import { device_px, primary } from "@/styles/variable"
import styled from "styled-components"

const { MAX_767 } = device_px

export const HeroSectionContainer = styled.div`
  width: 100%;
  padding: 30px 20px 0px 20px;
`

export const HeroSectionContent = styled.div`
  width: 100%;
  @media screen and (max-width: ${MAX_767}) {
    display: flex;
    width: 290px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 2px;
  }
`

export const HeroSectionTitle = styled.div`
  margin-bottom: 10px;
  @media screen and (max-width: ${MAX_767}) {
    color: ${primary.foreground};
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 33.6px */
    letter-spacing: -1.2px;
  }
`

export const HeroSectionSubTitle = styled.div`
  @media screen and (max-width: ${MAX_767}) {
    color: ${primary.foreground};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 16.8px */
    letter-spacing: -0.06px;
  }
`
